import type { Options } from '@splidejs/splide'

import Splide from '@splidejs/splide'

/**
 * Standard Splide configuration for image galleries
 */
const defaultConfig: Options = {
  drag: true,
  gap: 0,
  lazyLoad: false,
  pagination: false,
  perPage: 1,
  type: 'loop'
}

/**
 * Get the default Splide configuration
 */
export const getDefaultConfig = (): Options => ({ ...defaultConfig })

/**
 * Initialize a Splide slider with optional custom configuration
 */
export const initialize = (element: HTMLElement, customConfig?: Partial<Options>): Splide => {
  const finalConfig = { ...defaultConfig, ...customConfig }
  return new Splide(element, finalConfig).mount()
}

/**
 * Setup counter text that updates on slide change (for DOM-based counters)
 */
export const setupCounter = (container: HTMLElement, splide: Splide, totalSlides: number, counterSelector: string = '.immo-map-popup__counter-text'): void => {
  const counterText = container.querySelector(counterSelector)
  if (counterText !== null) {
    splide.on('moved', () => {
      counterText.textContent = `${splide.index + 1}/${totalSlides}`
    })
  }
}

/**
 * Setup counter with callback (for reactive state updates in Svelte components)
 */
export const setupCounterWithCallback = (splide: Splide, callback: (currentIndex: number) => void): void => {
  splide.on('moved', () => {
    callback(splide.index + 1)
  })
}

/**
 * Setup navigation buttons for a Splide instance
 */
export const setupNavigation = (container: HTMLElement, splide: Splide, prevSelector: string = '.immo-results__nav--prev', nextSelector: string = '.immo-results__nav--next'): void => {
  const prevButton = container.querySelector(prevSelector)
  const nextButton = container.querySelector(nextSelector)

  if (prevButton !== null) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      splide.go('<')
    })
  }

  if (nextButton !== null) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      splide.go('>')
    })
  }
}
